module.exports = __webpack_public_path__ + "img/dsci0101.c7705f04.jpg";